import { render, staticRenderFns } from "./SectionTitle.vue?vue&type=template&id=3258f61a&scoped=true"
var script = {}
import style0 from "./SectionTitle.vue?vue&type=style&index=0&id=3258f61a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3258f61a",
  null
  
)

export default component.exports